import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";
import * as V from "../../../../utils/formValidation";
import Password from "../../../../components/form/Password";
import { isNil } from "lodash";
import { jipLoginAction, samlLoginAction } from "../../../../utils/login";

class KerberosLoginForm extends Component {
  render() {
    const {
      error,
      handleSubmit,
      onSubmit,
      goBack,
      submitting,
      disabled,
      title,
    } = this.props;

    return (
      <div className="publicLoginPage">
        <div className="publicLoginCard">
          <div className="publicLoginCard__header">
            <div className="publicLoginCard__title">{title}</div>
          </div>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="publicLoginCard__form"
          >
            {error && <div className="error">{error}</div>}

            <div className="publicLoginCard__actions center">
              <Button
                type="submit"
                style={styles.buttons}
                label="Přihlásit přes kerberos"
                disabled={submitting || disabled}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

class LoginForm extends Component {
  state = {};

  async componentWillMount() {
    const { query } = this.props;
    if (!isNil(query)) {
      if (!isNil(query.sessionId)) {
        const {
          query: { sessionId },
        } = this.props;
        try {
          await jipLoginAction(sessionId)(this.props.dispatch);
        } catch (e) {
          const {
            errors: { _error },
          } = e;
          this.setState({ error: _error });
        }
      } else if (!isNil(query.officialHash)) {
        const {
          query: { officialHash },
        } = this.props;
        try {
          await samlLoginAction(officialHash, "official")(this.props.dispatch);
        } catch (e) {
          const {
            errors: { _error },
          } = e;
          this.setState({ error: _error });
        }
      } else if (!isNil(query.publicHash)) {
        const {
          query: { publicHash },
        } = this.props;
        try {
          await samlLoginAction(publicHash, "public")(this.props.dispatch);
        } catch (e) {
          const {
            errors: { _error },
          } = e;
          this.setState({ error: _error });
        }
      }
    }
  }

  jipRedirect = () => {
    const { role } = this.props;
    switch (role) {
      case "legitimate":
        window.location = "/opravneny-organ/api/auth/jip";
        break;
      case "ovm":
        window.location = "/podpurny-organ/api/auth/jip";
        break;
      default:
        break;
    }
  }

  render() {
    const {
      error,
      handleSubmit,
      onSubmit,
      goBack,
      submitting,
      disabled,
      jipButton,
      niaButton,
      role,
      title,
    } = this.props;

    const niaRole =
      role === "official"
        ? "OFFICIAL"
        : role === "public"
          ? "PUBLIC_USER"
          : null;
    const niaLoginHref = niaRole
      ? `/saml2/authenticate/nia?role=${niaRole}`
      : "/saml2/authenticate/nia";

    return (
      <div className="publicLoginPage">
        <div
          className={`publicLoginCard${niaButton ? " publicLoginCard--wide" : ""}`}
        >
          <div className="publicLoginCard__header">
            <div className="publicLoginCard__title">{title}</div>
          </div>

          <div className={niaButton ? "publicLoginMethods" : ""}>
            {niaButton && (
              <div className="publicLoginMethods__left">
                <div className="publicLoginMethods__title">NIA</div>
                <div className="publicLoginMethods__text">
                  Prostřednictvím NIA
                </div>

                <a
                  className="publicLoginMethods__niaLink"
                  href={niaLoginHref}
                >
                  <img
                    alt="identita login"
                    src="/identita-obcana.png"
                    className="publicLoginMethods__niaLogo"
                  />
                </a>
              </div>
            )}

            {niaButton && (
              <div className="publicLoginMethods__divider">nebo</div>
            )}

            <div className="publicLoginMethods__right">
              {niaButton && (
                <div className="publicLoginMethods__title">
                  Přihlašovacími údaji
                </div>
              )}
              {role === "official" && (
                <div className="publicLoginMethods__text">
                  Přidělenými podpůrným orgánem
                </div>
              )}
              {role === "public" && (
                <div className="publicLoginMethods__text">
                  Přidělenými správcem
                </div>
              )}
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="publicLoginCard__form"
              >
                <div className="publicLoginFields">
                  <Field
                    placeholder="Přihlašovací jméno"
                    name="username"
                    component={Input}
                    disabled={disabled}
                    validate={[V.required]}
                    inputProps={{ 'aria-label': 'Přihlašovací jméno' }}
                  />
                  <Field
                    placeholder="Heslo"
                    name="password"
                    component={Password}
                    disabled={disabled}
                    validate={[V.required]}
                    fullWidth
                    inputProps={{ 'aria-label': 'Heslo' }}
                  />
                </div>

                <div className="publicLoginCard__actions">
                  <Button
                    type="submit"
                    style={styles.buttons}
                    label="Přihlásit"
                    disabled={submitting || disabled}
                  />
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zpět"
                    disabled={submitting || disabled}
                    onClick={goBack}
                  />
                  {jipButton && (
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Přihlásit přes JIP"
                      disabled={submitting || disabled}
                      onClick={this.jipRedirect}
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
          {error && (
            <div className="error" style={{ textAlign: "center" }}>
              {error}
            </div>
          )}
          {this.state.error && (
            <div className="error" style={{ textAlign: "center" }}>
              {this.state.error}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export const KerberosForm = reduxForm({
  form: "loginForm",
})(KerberosLoginForm);

export default reduxForm({
  form: "loginForm",
})(LoginForm);

export const DevLoginForm = reduxForm({
  form: "devLoginForm",
})(LoginForm);
